import { render } from "./transferlist.vue?vue&type=template&id=2e2e2a84"
import script from "./transferlist.vue?vue&type=script&lang=js"
export * from "./transferlist.vue?vue&type=script&lang=js"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__